import { ReactNode } from 'react';
import { Box } from '@mui/material';

type TypeProps = {
  children: ReactNode;
  index: number;
  value: number;
  noBorder?: boolean;
};

export function TabPanel({ children, value, index, noBorder = false }: TypeProps) {
  return (
    <div hidden={value !== index}>
      {value === index && (
        <Box
          sx={({ palette }) => ({
            ...(noBorder
              ? { paddingTop: 3 }
              : { padding: '16px 16px 4px', borderTop: `1px solid ${palette.grey[600]}` }),
          })}
        >
          {children}
        </Box>
      )}
    </div>
  );
}
